import { render, staticRenderFns } from "./NotifiedModal.vue?vue&type=template&id=025dd5ae&scoped=true"
import script from "./NotifiedModal.vue?vue&type=script&lang=js"
export * from "./NotifiedModal.vue?vue&type=script&lang=js"
import style0 from "./NotifiedModal.vue?vue&type=style&index=0&id=025dd5ae&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025dd5ae",
  null
  
)

export default component.exports